import React from 'react';
import { Redirect, Link } from 'react-router-dom';

import NavBarLateral from '../NavBarLateral/index';

class AdminError extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            isLogged: this.props.auth,
        };
    }

    render(){
        if(this.state.isLogged === true){
            return (
                <div>
                    <NavBarLateral />
                    <div className={`pad`}>
                        <NavTitulo />
                        <div className={`row`}>
                            <TarjetaProcesoExitoso 
                                texto={this.props.location.state.descripcionError}
                                rutaRegreso={this.props.location.state.rutaRegreso}/>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return <Redirect to="/administrador/login"/>
        }
    }
}

class TarjetaProcesoExitoso extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col s12 m1 l3"></div>
                    <div class="col s12 m10 l6">
                        <div class="card">
                            <div class="card-content teal">
                                <span class="card-title white-text"><i class="material-icons">check_circle</i> Proceso Correcto</span>
                            </div>
                            <div class="card-content">
                                <p className="">{this.props.texto}</p>
                            </div>
                            <div class="card-action">
                                <Link to={this.props.rutaRegreso}>
                                    <a class="waves-effect waves-light btn teal">
                                        <i class="material-icons right">send</i>
                                        Regresar
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </div>
                <div className="col s12 m1 l3"></div>
            </div>
        );
    }
}

class NavTitulo extends React.Component{
    render(){
        return(
            <div className="navbar-fixed">
                <nav className="light-blue">
                    <div className="nav-wrapper">
                        <a className="brand-logo margin-titulo-especiales">
                                Exitoso
                                <span 
                                    className="new badge red lighten-1 margin-badge-nav"
                                    data-badge-caption="operación correcta">
                                    {this.props.cantidad}
                                </span>
                        </a>
                    </div>
                </nav>
            </div>
         
        );
    }
}

export default AdminError; 